import {
    CHECK_SMS_KEY,
    CREATE_USER,
    FETCH_USER_DATA,
    FORGET_PASSWORD,
    RESET_PASSWORD,
    SEND_SMS_KEY,
    UPDATE_MOBILE,
    UPDATE_PASSWORD,
    UPDATE_USER_DATA
} from '../constants/user';

export function fetchUserData() {
    return ({
        type: FETCH_USER_DATA,
        api: true,
        auth: true,
        payload: {
            method: 'GET',
            url: '/users/user'
        }
    });
}

export function createUser(data) {
    return ({
        type: CREATE_USER,
        api: true,
        payload: {
            method: 'POST',
            url: '/users/users',
            data
        }
    });
}

export function updateUserData(data) {
    return ({
        type: UPDATE_USER_DATA,
        api: true,
        auth: true,
        payload: {
            method: 'PATCH',
            url: '/users/user',
            data
        }
    });
}

export function updateMobileRequest(mobile, smsKey, validator) {
    return ({
        type: UPDATE_MOBILE,
        api: true,
        auth: true,
        payload: {
            method: 'PATCH',
            url: '/users/user/update-mobile',
            data: {mobile, smsKey, validator}
        }
    });
}

export function updatePasswordRequest(password) {
    return ({
        type: UPDATE_PASSWORD,
        api: true,
        auth: true,
        payload: {
            method: 'PATCH',
            url: '/users/user',
            data: {password}
        }
    });
}

export function sendSMSKeyRequest(mobile) {
    return ({
        type: SEND_SMS_KEY,
        api: true,
        auth: true,
        payload: {
            method: 'PATCH',
            url: '/users/users/send-sms-key',
            data: {mobile}
        }
    });
}

export function checkSMSKeyRequest(uid, smsKey) {
    return ({
        type: CHECK_SMS_KEY,
        api: true,
        payload: {
            method: 'PATCH',
            url: `/users/users/check-sms-key/${uid}`,
            data: {smsKey}
        }
    });
}

export function forgetPasswordRequest(mobile) {
    return ({
        type: FORGET_PASSWORD,
        api: true,
        payload: {
            method: 'PATCH',
            url: '/users/users/send-sms-key',
            data: {mobile}
        }
    });
}

export function resetPasswordRequest(uid, token, password) {
    return ({
        type: RESET_PASSWORD,
        api: true,
        payload: {
            method: 'PATCH',
            url: `/users/users/forget-password/reset-password/${uid}/${token}`,
            data: {password}
        }
    });
}
